import React from "react";
import ReactSwitch from "react-switch";
import { useTranslation } from "react-i18next";

import { ModeOfSaleRow } from "@components/Common/PrinterSetting/stores";

import "../index.css";

type ModeSwitchListProps = {
    /** Translation key for the row label. */
    label: string;
    /** Full data-testid prefix; the final id is `${testIdPrefix}-${index}-switch`. */
    testIdPrefix: string;
    rows: readonly ModeOfSaleRow[];
    onToggle: (modeOfSale: ModeOfSaleRow, index: number) => void;
};

export default function ModeSwitchList({
    label,
    testIdPrefix,
    rows,
    onToggle,
}: ModeSwitchListProps) {
    const { t } = useTranslation();
    return (
        <div className="d-flex  align-items-center flex-wrap ">
            <label className="p-2" style={{ width: "10%" }}>
                {t(label)}
            </label>
            {rows.map((modeOfSale, index) => (
                <div
                    className="text-danger row b-2 align-items-center"
                    key={`${testIdPrefix}-${index}`}
                >
                    <div className="d-flex col-4" style={{ color: "#212529 " }}>
                        <div className="px-1">
                            <h6 style={{ width: "87px" }}>
                                {modeOfSale.designation}
                            </h6>
                        </div>
                        <div className="mr-2">
                            <ReactSwitch
                                uncheckedIcon={false}
                                checkedIcon={false}
                                handleDiameter={26}
                                offColor="#f7b4b8"
                                offHandleColor="#E30613"
                                checked={modeOfSale.state}
                                onChange={() => onToggle(modeOfSale, index)}
                                onColor="#c2eddd"
                                onHandleColor="#34C38F"
                                width={55}
                                height={20}
                                className="fed_icn_FRmodeOfSales"
                                aria-label={t(modeOfSale.designation)}
                                data-testid={`${testIdPrefix}-${index}-switch`}
                            />
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
}
